import React from "react";
const SampleNextArrow = props => {
  const {
    className, onClick 
  } = props;

  return (
    <span className={className} onClick={onClick}>
      <svg
        width='17'
        height='31'
        viewBox='0 0 17 31'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M1 1L15.5 15.5L1 30' stroke='#80583F' />
      </svg>
    </span>
  );
}

export default SampleNextArrow
